module.exports = __webpack_public_path__ + "static/media/arties2.985e2068.jpg";